import { FC } from "react";
import { COLOR_WHITE } from "../colors";
import { IconType } from "./types";

export const HeadingTwoIcon: FC<IconType> = ({ color = COLOR_WHITE }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0601 15.0967V17.0391H7.75146V15.0967H14.0601ZM8.49023 10.1743V22.2603H6V10.1743H8.49023ZM15.8364 10.1743V22.2603H13.3545V10.1743H15.8364Z"
      fill={color}
    />
    <path
      d="M26.0215 20.3926V22.2603H17.7539V20.6665L21.6636 16.4746C22.0565 16.0374 22.3664 15.6528 22.5933 15.3208C22.8202 14.9832 22.9834 14.6816 23.083 14.416C23.1882 14.1449 23.2407 13.8875 23.2407 13.644C23.2407 13.2788 23.1798 12.9661 23.0581 12.7061C22.9364 12.4404 22.7565 12.2357 22.5186 12.0918C22.2861 11.9479 21.9984 11.876 21.6553 11.876C21.29 11.876 20.9746 11.9645 20.709 12.1416C20.4489 12.3187 20.2497 12.5649 20.1113 12.8804C19.9785 13.1958 19.9121 13.5527 19.9121 13.9512H17.5132C17.5132 13.2318 17.6847 12.5732 18.0278 11.9756C18.3709 11.3724 18.8551 10.8937 19.4805 10.5396C20.1058 10.1799 20.8473 10 21.7051 10C22.5518 10 23.2656 10.1383 23.8467 10.415C24.4333 10.6862 24.876 11.0791 25.1748 11.5938C25.4792 12.1029 25.6313 12.7116 25.6313 13.4199C25.6313 13.8184 25.5677 14.2085 25.4404 14.5903C25.3132 14.9666 25.1305 15.3429 24.8926 15.7192C24.6602 16.09 24.3779 16.4663 24.0459 16.8481C23.7139 17.23 23.3459 17.6257 22.9419 18.0352L20.8418 20.3926H26.0215Z"
      fill={color}
    />
  </svg>
);
